import React, { createContext, useContext } from "react";
import { usePageSearch } from "hooks/usePageSearch";

interface SearchContextType {
  isOpen: boolean;
  searchTerm: string;
  filteredPages: any[];
  selectedIndex: number;
  openSearch: () => void;
  closeSearch: () => void;
  handleSearchChange: (event: any) => void;
  setSelectedIndex: (index: number) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider = ({ children }: any) => {
  const searchState = usePageSearch();

  return (
    <SearchContext.Provider value={searchState}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = (): SearchContextType => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext must be used within a SearchProvider');
  }
  return context;
};